const faqs = [
  {
    q: "Who is the club for?",
    a: "Women in Manteca and the broader 209 who love reading and want a real-life community around it. If you're a little farther out and willing to make the drive for meetups, you're welcome too.",
  },
  {
    q: "How are books picked?",
    a: "The hosts pick the next book each month, with a steady ear to what members are suggesting. You can submit a book in your application, and there's a thread for it in the portal once you're in.",
  },
  {
    q: "What if I can't finish a book?",
    a: "Come anyway. Truly. We'd rather have you there at 60% than at home feeling weird about it. Spoiler warnings are just a courtesy we extend to each other.",
  },
  {
    q: "How does the $5 work?",
    a: "It's a recurring monthly subscription that renews on the day you joined. You can update your card or cancel any time from inside the portal. If a renewal fails, you have about a week to fix it before access pauses.",
  },
  {
    q: "Is there anywhere to message other members?",
    a: "No, by design. The portal has a discussion feed for talking about the book, but it isn't a DM app. Real friendships happen in person at meetups, not in a chat window.",
  },
  {
    q: "What if I don't get accepted?",
    a: "We keep the group small so the conversations stay good. If we can't make space right now, we'll let you know — and you're welcome to apply again later.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="section">
      <div className="container">
        <div className="split split--5-7">
          <div>
            <div className="eyebrow">Questions</div>
            <h2
              className="display display--lg"
              style={{ marginTop: "1rem", marginBottom: "0.75rem" }}
            >
              the small print,
              <br />
              kindly.
            </h2>
            <p>Can't find what you're looking for? Drop it in the application — we read every word.</p>
          </div>
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {faqs.map((f, i) => (
              <li
                key={f.q}
                style={{
                  borderTop: i === 0 ? "1px solid var(--c-brass)" : undefined,
                  borderBottom: "1px solid var(--c-brass)",
                  paddingBlock: "1.5rem",
                }}
              >
                <details>
                  <summary
                    style={{
                      cursor: "pointer",
                      listStyle: "none",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "1rem",
                      fontFamily: "var(--f-display)",
                      fontStyle: "italic",
                      fontWeight: 900,
                      fontSize: "clamp(1.2rem, 2.4vw, 1.65rem)",
                      color: "var(--c-palm)",
                      lineHeight: 1.2,
                      textTransform: "lowercase",
                    }}
                  >
                    <span>{f.q}</span>
                    <span
                      aria-hidden="true"
                      style={{
                        color: "var(--c-coral)",
                        fontFamily: "var(--f-body)",
                        fontStyle: "normal",
                        fontWeight: 600,
                        fontSize: "1.4rem",
                      }}
                    >
                      +
                    </span>
                  </summary>
                  <p style={{ marginTop: "0.85rem", marginBottom: 0, lineHeight: 1.65 }}>
                    {f.a}
                  </p>
                </details>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
